import { useEffect } from "react";
import "../Profile/index.less";
import { effect, useStore } from "../../../utils/dva16";
import { NLogin, EGet, NGamerInsightNote } from "../../../models/contants";
import { Helmet } from "react-helmet";
import { customizeRenderEmpty } from "../../../utils/utils";
import { Divider } from "antd";

const IFRAME_CONFIGS = {
	"All Regions":
		"https://app.powerbi.com/view?r=eyJrIjoiYWUzZDZkYzItM2JmNS00NDQ3LTg5MjMtMzIwMDZmNjk4Y2EyIiwidCI6IjQ5NDkyZjUwLTk2NTEtNGYyNC1hYjFkLWMzNmQ0NzRlNWZmMyIsImMiOjZ9",
	China:
		"https://app.powerbi.com/view?r=eyJrIjoiNjg1MjM2ZTItNmRlMS00NDg3LThmYjctMTNiYTBkYWIwYWJlIiwidCI6IjQ5NDkyZjUwLTk2NTEtNGYyNC1hYjFkLWMzNmQ0NzRlNWZmMyIsImMiOjZ9",
	"China + East Asia":
		"https://app.powerbi.com/view?r=eyJrIjoiYzY0YWM0MGYtMzA1MS00MzY4LWE4ZjctNjg3MTUxZDExOTNhIiwidCI6IjQ5NDkyZjUwLTk2NTEtNGYyNC1hYjFkLWMzNmQ0NzRlNWZmMyIsImMiOjZ9",
	MENA: "https://app.powerbi.com/view?r=eyJrIjoiNzYyYjBkYjgtNzI5My00NGM1LTk0MDktZDBmMmFlMGYzODZmIiwidCI6IjQ5NDkyZjUwLTk2NTEtNGYyNC1hYjFkLWMzNmQ0NzRlNWZmMyIsImMiOjZ9",
	"East Asia":
		"https://app.powerbi.com/view?r=eyJrIjoiY2NiMWI4MTktMDBmNS00OGM4LTg2OTctMWNhNTY1YzMxMGI4IiwidCI6IjQ5NDkyZjUwLTk2NTEtNGYyNC1hYjFkLWMzNmQ0NzRlNWZmMyIsImMiOjZ9",
	SEA: "https://app.powerbi.com/view?r=eyJrIjoiOTJhYjNjMTgtOWE2Zi00NTNmLWE1MTgtNzlhMmU5NTljOGJiIiwidCI6IjQ5NDkyZjUwLTk2NTEtNGYyNC1hYjFkLWMzNmQ0NzRlNWZmMyIsImMiOjZ9",
	India:
		"https://app.powerbi.com/view?r=eyJrIjoiYjE5NTRiY2ItOGQyNC00YmZiLWIyMGItMjljMzNkNDhiYzA5IiwidCI6IjQ5NDkyZjUwLTk2NTEtNGYyNC1hYjFkLWMzNmQ0NzRlNWZmMyIsImMiOjZ9",
};

const GamerInsightIframe = ({ title, src }) => (
	<iframe
		title={`Player Survey - ${title}`}
		style={{ width: "100%", height: "100vh", margin: "20px" }}
		src={src}
		frameBorder="0"
		allowFullScreen
	/>
);

export default (props) => {
	const { currentSubscribe, userInfo } = useStore(NLogin);
	const { gamerInsightNotes } = useStore(NGamerInsightNote);

	useEffect(() => {
		effect(NLogin, EGet, {});
		effect(NGamerInsightNote, EGet);
	}, []);

	const getIframeToRender = () => {
		if (userInfo?.type !== "Client") {
			// Non-client default view
			return (
				<GamerInsightIframe
					title="Default"
					src={IFRAME_CONFIGS["All Regions"]}
				/>
			);
		}

		const modules = currentSubscribe?.module?.["GamerInsights"];
		if (!modules || modules?.length === 0) return customizeRenderEmpty();

		const hasChina = modules?.includes("China");
		const hasEastAsia = modules?.includes("East Asia");

		if (modules?.length === 1 && hasChina) {
			return <GamerInsightIframe title="China" src={IFRAME_CONFIGS["China"]} />;
		}

		if (modules?.length === 2 && hasChina && hasEastAsia) {
			return (
				<GamerInsightIframe
					title="China + East Asia"
					src={IFRAME_CONFIGS["China + East Asia"]}
				/>
			);
		}

		if (modules?.length === 5) {
			return (
				<GamerInsightIframe
					title="All Regions"
					src={IFRAME_CONFIGS["All Regions"]}
				/>
			);
		}

		// If multiple modules, render them all
		return modules?.map((region) =>
			IFRAME_CONFIGS[region] ? (
				<GamerInsightIframe
					key={region}
					title={region}
					src={IFRAME_CONFIGS[region]}
				/>
			) : null,
		);
	};

	return (
		<div style={{ margin: "20px" }}>
			<Helmet>
				<script
					dangerouslySetInnerHTML={{
						__html: `
                            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                            })(window,document,'script','dataLayer','GTM-N9T2Q4PW');
                        `,
					}}
				/>
				{/* Google tag (gtag.js) */}
				<script
					async
					src="https://www.googletagmanager.com/gtag/js?id=G-6049TJDB50"
				></script>
				<script>
					{`
         				window.dataLayer = window.dataLayer || [];
        				function gtag(){dataLayer.push(arguments);}
          			gtag('js', new Date());
         				gtag('config', 'G-6049TJDB50');
        	`}
				</script>
			</Helmet>

			{getIframeToRender()}

			<Divider
				style={{
					borderWidth: "2px",
					borderColor: "rgb(219 218 218)",
					margin: "25px 20px",
				}}
			/>
			<div
				className="gamerInsightNotes"
				dangerouslySetInnerHTML={{
					__html: gamerInsightNotes && gamerInsightNotes?.[0]?.note,
				}}
				style={{ margin: "0 20px" }}
			/>
		</div>
	);
};
